import React from 'react'

function Loader() {
    return (
        <div className="loader-wrapper">
        <div className="loader bg-white">
            <div className="whirly-loader"> </div>
        </div>
        </div>
    )
}

export default Loader
